import Vue from 'vue';

export default {
	install(Vue) {

		Vue.prototype.$gameData = Vue.observable({
			scale: 1,
			client: null,
			dialogs: {},
			toast: null,
			mqttData: null,
			gameStarted: false,
			// 반응형 현재시각 — 라운드 판정(round computed)이 시간 경과만으로 재계산되게 한다
			now: '',
		})
		Vue.prototype.$adminData = Vue.observable({
			admin: {},
			tabIndex: -1,
			tabSubIndex: -1,
			training: {}
		})

		Vue.prototype.$userData = Vue.observable({
			user: {},
			teamData: {},
			setting: {},
			deliveries: [],
			data: {},
			inventories: [],
		})
	}
	
}